<template>
  <div class="app-wrapper">
    <!-- <div class="fixed-header">
        <div class="navbar">
            <div class="tarbar_left">
                <div>
                    <p class="noMain">
                        <span class="shop-name">重庆鑫斛药房连锁有限公司</span>
                        <i class="el-icon-arrow-down"></i>
                    </p>
                </div>
            </div>
        </div>
    </div> -->
    <div class="main-container">
        <div>
            <div class="sidebar-container">
                <div class="plform_avar">
                    <img src="../assets/storelogo.png">
                    <span>平台管理系统</span>
                </div>
                <div class="plform_box">
                    <el-menu :default-active="activeIndex" @select="handleOpen" background-color="#292929" text-color="#fff" active-text-color="#409EFF" class="el-menu-demo">
                        <el-menu-item v-for="(item,index) in menu_arr" :key="index" :index="index.toString()">
                            <template slot="title">
                                <i class="el-icon-menu"></i>
                                <span>{{item.name}}</span>
                            </template>
                        </el-menu-item>
                    </el-menu>
                </div>
            </div>
        </div>
        <section class="app-main">
          <div id="app">
            <div class="headers_box">
                <div class="title_box">
                    <span>鑫斛</span>
                    <div class="istoggle">
                        <i class="el-icon-s-fold" v-if="isCollapse" @click="isToggle"></i>
                        <i class="el-icon-s-unfold" v-if="!isCollapse" @click="isToggle"></i>
                    </div>
                </div>
                <div class="user_info">
                    <div class="message" @click="messages">
                        <i class="el-icon-bell"></i>
                        <span>5</span>
                    </div>
                    <el-dropdown @command="handleCommand">
                        <span class="el-dropdown-link">
                            {{user_info.username}}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="a">修改密码</el-dropdown-item>
                            <el-dropdown-item command="b">退出登录</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
            <div class="main_content">
                <div class="children_menu" :style="styleObject">
                    <el-menu :default-active="activeIndex" :collapse="isCollapse" :default-openeds="openeds_arr" background-color="#e4e4e4" text-color="#4a4a4a" active-text-color="#ffd04b" class="el-menu-demo">
                        <el-submenu v-for="(item,index) in sonMenu" :key="index" :index="index.toString()">
                            <template slot="title">
                                <i v-if="isCollapse" class="el-icon-menu"></i>
                                <span>{{item.name}}</span>
                            </template>
                            <el-menu-item v-for="(value,elindex) in item.sonMenu" :key="elindex" :index="index.toString()+'-'+elindex.toString()">
                                <router-link active-class="is-active" class="custom-router-a" :to="value.page_path">{{value.name}}</router-link>
                            </el-menu-item>
                        </el-submenu>
                    </el-menu>
                </div>
                <div class="content" :style="styleObject1">
                     <router-view/>
                </div>
            </div>
          </div>
        </section>
    </div>
    <el-dialog title="修改密码" :visible.sync="dialogFormVisible">
        <el-form :model="form" :rules="rules" ref="ruleForm" label-width="90px">
            <el-form-item label="名称" prop="username">
               <el-input v-model="user_info.username" disabled autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="账号" prop="phone">
               <el-input v-model="user_info.phone" disabled autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="password">
               <el-input v-model="form.password" autocomplete="off" :minlength="6" placeholder="长度限制6-20位" :maxlength="20" show-password clearable></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="again_password">
               <el-input v-model="form.again_password" autocomplete="off" :minlength="6" placeholder="长度限制6-20位" :maxlength="20" show-password clearable></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="merchant_pwd('ruleForm')">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
    import axios from '@/utils/request';
    export default {
      name: 'Layout',
      data() {
            return {
                activeIndex:'0',
                user_info:{},
                dialogFormVisible:false,
                form:{
                    password:'',
                    again_password:'',
                },
                rules: {
                    company_name: [
                        { required: true, message: '请输入商户名称', trigger: 'blur' },
                    ],
                    merchant_id: [
                        { required: true, message: '请输入商户账号', trigger: 'blur' },
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' },
                    ],
                    again_password: [
                        { required: true, message: '请输入确认密码', trigger: 'blur' },
                    ],
                },
                menu_arr:[],
                sonMenu:[],
                isCollapse: false,
                styleObject:{
                    width:'150px'
                },
                styleObject1:{
                    left:'150px'
                },
                openeds_arr:['0']
            }
        },
        mounted(){
           this.menu()
           this.getData()
        },
        watch: {
            $route(to, from) {
                this.update_meun(to.path)
            }
        },
        methods:{
            getData(){
                axios.get('/user_info')
                    .then(res => {
                        if(res.code == 0){
                           this.user_info = res.data
                        }
                    })
                    .catch(error => {
                        console.error('There was an error!', error);
                    });
            },
            isToggle(){
                this.isCollapse = !this.isCollapse
                if(this.isCollapse){
                    this.styleObject = {
                        width:'64px'
                    }
                    this.styleObject1 = {
                        left:'64px',
                        width: 'calc(100% - 84px)'
                    }
                }else{
                    this.styleObject = {
                        width:'150px'
                    }
                    this.styleObject1 = {
                        left:'150px',
                        width: 'calc(100% - 170px)'
                    }
                }
            },
            menu(){
                const that = this
                axios.get('/user_menu')
                    .then(res => {
                        this.menu_arr = res.data
                        this.update_meun(that.$router.currentRoute.fullPath)
                    })
                    .catch(error => {
                        console.error('There was an error!', error);
                    });
            },
            update_meun(path){
                let menu_id = ''
                let activeIndex = ''
                this.menu_arr.forEach(function(item,index){
                    if(item.sonMenu&&item.sonMenu.length>0){
                        item.sonMenu.forEach(function(scond){
                            scond.sonMenu.forEach(function(end){
                                if(end.page_path == path){
                                    menu_id = item.menu_id
                                    activeIndex = index
                                }else{
                                    let newPath = end.page_path.replace(/\//g, ''); 
                                    let includes = path.includes(newPath)
                                    if(includes){
                                        menu_id = item.menu_id
                                        activeIndex = index
                                    }
                                }
                            })
                        })
                    }
                })
                const resultArr = this.menu_arr.filter(item => item.menu_id === menu_id);
                if(resultArr.length>0){
                    this.sonMenu = resultArr[0].sonMenu
                    this.activeIndex = activeIndex.toString()
                }
            },
            handleCommand(command){
                const that = this
                if(command == 'a'){
                   this.dialogFormVisible = true
                }else if(command == 'b'){
                    this.$confirm('退出登录, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        axios.get('/logout')
                            .then(res => {
                                localStorage.clear();
                                setTimeout(function(){
                                    that.$router.push({ path: "/"});
                                },500)
                            })
                            .catch(error => {
                                console.error('There was an error!', error);
                            });
                    }).catch(() => {
                                 
                    });
                }
            },
            merchant_pwd(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(this.form.password !== this.form.again_password){
                        this.$message.error('输入的两次密码不相同！');
                        }else{
                            const data = {
                                user_id:this.user_info.id,
                                password:this.form.password,
                                again_password:this.form.again_password
                            }
                            axios.post('/admin_pwd',data)
                            .then(res => {
                                this.$message.success(res.message);
                                this.dialogFormVisible = false
                            })
                            .catch(error => {
                                console.error('There was an error!', error);
                            });
                        }
                        
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            handleOpen(index) {
              this.sonMenu = this.menu_arr[index].sonMenu
              let opens = Array.from({ length: this.sonMenu.length }, (v, k) => k + 1);
              this.openeds_arr = opens.map(number => (number-1).toString());
               this.$router.push({ path: this.sonMenu[0].sonMenu[0].page_path });
            },
            messages(){
                this.$router.push({ name: 'message_center'})
            },
        }
    }
</script>
<style lang="less" scoped>

.title_box{
    display: flex;
    align-items: center;
    .istoggle{
        display: flex;
        margin-left:5px;
        i{
            font-size: 26px;
            color: #4a4a4a;
            cursor: pointer;
        }
    }
}
.main_content{
    height: 100%;
}
.custom-router-link{
    text-decoration: none;
    color: #fff;
    display: block;
}
.custom-router-a{
    text-decoration: none;
    color: #4a4a4a;
    display: block;
}
.is-active{
    color: #409EFF; 
}
.children_menu{
    width: 150px;
    transition: width 0.28s;
    background-color: #e4e4e4;
    // height: calc(100vh-60px);
    height: calc(100% - 60px);
    position: fixed;
    font-size: 0;
    top: 60px;
    bottom: 0;
    left: 170px;
    z-index: 996;
    overflow-x: hidden;
}
.app-wrapper{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    position: relative;
    height: 100%;
    width: 100%;
    .fixed-header{
        position: fixed;
        top: 0;
        right: 0;
        z-index: 999;
        width: 100%;
        height: 68px;
        -webkit-transition: width .28s;
        transition: width .28s;
        .navbar{
            height: 68px;
            padding: 0 24px 0 0;
            background: #fff;
            -webkit-box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
            box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            font-size: 26px;
            min-width: 900px;
            .tarbar_left{
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                padding: 0 0 0 20px;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                -webkit-box-flex: 1;
                -ms-flex: 1;
                flex: 1;
                .noMain{
                    margin-top: 0;
                    line-height: 68px;
                    cursor: pointer;
                    .shop-name{
                        font-size: 24px;
                        font-weight: 500;
                        color: #131414;
                        cursor: pointer;
                    }
                }
            }
        }
    }
    .main-container{
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        -webkit-transition: margin-left .28s;
        transition: margin-left .28s;
        margin-left: 170px;
        position: relative;
        .sidebar-container{
            -webkit-transition: width .28s;
            transition: width .28s;
            width: 170px !important;
            background-color: #292929;
            height: calc(100%);
            position: fixed;
            font-size: 0;
            top: 0px;
            bottom: 0;
            left: 0;
            z-index: 996;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            .plform_avar{
                height: 130px;
                img{
                    // width: 80px;
                    height: 80px;
                    // border-radius: 50%;
                    display: block;
                    margin: auto;
                    margin-top: 10px;
                }
                span{
                    font-size: 18px;
                    text-align: center;
                    display: block;
                    color: #fff;
                    margin-top: 10px;
                }
            }
            .plform_box{
                flex: 1;
                overflow: auto;
            }
        }
        .app-main{
            min-height: calc(100vh);
            height: 100%;
            // width: calc(100% - 48px);
            min-width: 1000px;
            position: relative;
            overflow: hidden;
            #app{
                height: 100%;
                display: flex;
                flex-direction: column;
                .headers_box{
                    display: flex;
                    justify-content: space-between;
                    background: #fff;
                    height:60px;
                    line-height:60px;
                    span{
                        margin-left: 10px;
                    }
                    .user_info{
                        cursor: pointer;
                        margin-right: 10px;
                        display: flex;
                        align-items: center;
                        .message{
                            width: 30px;
                            height: 30px;
                            position: relative;
                            margin-right: 10px;
                            display: flex;
                            i{
                                font-size: 30px;
                            }
                            span{
                                width: 16px;
                                height: 16px;
                                position: absolute;
                                top: 0;
                                right: 0;
                                background: #e00000;
                                border-radius: 50%;
                                color: #ffffff;
                                line-height: 16px;
                                text-align: center;
                                font-size: 14px;
                            }
                        }
                    }
                }
                .content{
                    margin: 10px;
                    background: #fff;
                    border-radius: 5px;
                    position: relative;
                    left: 150px;
                    width: calc(100% - 170px);
                    height: calc(100% - 20px);
                }
            }
        }
    }
}
</style>